import React, { useState } from 'react';

interface StepCardProps {
  stepNumber: string;
  title: string;
  subtitle?: string;
  isPreview?: boolean;
  isExpandable?: boolean;
  isOptional?: boolean;
  defaultExpanded?: boolean;
  children: React.ReactNode;
}

const StepCard: React.FC<StepCardProps> = ({ 
  stepNumber, 
  title, 
  subtitle, 
  isPreview = false,
  isExpandable = false,
  isOptional = false,
  defaultExpanded = false,
  children 
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleToggle = () => {
    if (isExpandable) {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className={`step-card ${isPreview ? 'preview-card' : ''} ${isExpandable ? 'expandable' : ''}`}>
      <div 
        className={`step-header ${isExpandable ? 'clickable' : ''}`}
        onClick={handleToggle}
      >
        <span className="step-number">{stepNumber}</span>
        <h2>
          {title}
          {isOptional && (
            <span className="optional-badge">Optional</span>
          )}
        </h2>
        {isExpandable && (
          <button 
            className="expand-toggle"
            type="button"
            aria-label={isExpanded ? 'Collapse section' : 'Expand section'}
          >
            {isExpanded ? '▼' : '▶'}
          </button>
        )}
        {subtitle && (
          <p className="preview-subtitle">{subtitle}</p>
        )}
      </div>
      <div className={`step-content ${isExpandable && !isExpanded ? 'collapsed' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default StepCard; 